import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';

import { FETCH_ACCOUNT_HOLDER_NAME } from './allDocumentsBreadcrumb.query';

export const AllDocumentsBreadcrumb = () => {
  const { accountId } = useParams<{ accountId: string }>();
  const { data } = useQuery(FETCH_ACCOUNT_HOLDER_NAME, {
    variables: { id: accountId },
    skip: !accountId,
  });

  return data?.fetchAccount?.account?.user?.firstName ?? '';
};
